import React, { useEffect, useState } from "react"
import { throwApiError } from "../../../../store/error-handling-actions"
import { SourceTypeEnumText } from "../../../../models/SourceTypeEnum"
import { ActivityTypeEnumText } from "../../../../models/ActivityTypeEnum"
import { assessmentsApi } from "../../../../../../utils"
import QuestionText from "../QuestionTextPart/QuestionText"
import QuestionType from "../QuestionTypePart/QuestionType"
import classes from './ReflectionCrud.module.css'
import ReflectionToolBar from "../ReflectionToolBar/ReflectionToolBar"
import { AssessmentTypeConvertTextEnum } from "../../../../models/AssessmentTypeEnum"



const ReflectionCrud = ({
    reflection,
    lessonId,
    index,
    handleUpdateQuestion,
    handleCopyReflection,
    handleUpdateNewQuestion,
    handleDeleteQuestion,
    handleChangeOrder,
    portalId }) => {

    const [questionItem, setQuestion] = useState()

    const fetchCreate = (questionBody, type) => {
        if (questionBody && questionBody.type && questionBody.text) {
            var data = {
                lessonId: lessonId,
                sourceType: SourceTypeEnumText.SLCReflection,
                activityType: ActivityTypeEnumText.Reflection,
                assessmentTypeId: AssessmentTypeConvertTextEnum[questionBody.type],
                name: questionBody.text,
                contentData: JSON.stringify({ type: questionBody.type, text: questionBody.text }),
                sortIndex: type === 'COPY' ? reflection[reflection.length - 1].sortIndex + 1 : index
            }
            assessmentsApi.assessmentsAddPost({ assessmentAddInput: data }, (error, resdata, response) => {
                if (error) {
                    throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsAddPost " + error.message, level: 1, component: "ReflectionCrud", line: 113 })
                }
                else {
                    type === 'COPY' ?
                        handleCopyReflection({ ...JSON.parse(resdata.contentData), id: resdata.id, sortIndex: resdata.sortIndex }) :
                        handleUpdateNewQuestion({ ...JSON.parse(resdata.contentData), id: resdata.id, sortIndex: resdata.sortIndex })
                }
            })
        }
    }

    const fetchUpdate = (question) => {
        var data = {
            id: question.id,
            name: question?.text,
            contentData: JSON.stringify({ type: question?.type, text: question?.text })
        }
        assessmentsApi.assessmentsUpdatePost({ assessmentUpdateInput: data }, (error, resdata, response) => {
            if (error) {
                throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsUpdatePost " + error.message, level: 1, component: "ReflectionCrud", line: 136 })
            }
            else {
                handleUpdateQuestion(question)
            }
        })
    }

    const fetchDelete = (id) => {
        if (id) {
            assessmentsApi.assessmentsDeleteIdPost(id, (error, resdata, response) => {
                if (error) {
                    throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsDeleteIdPost " + error.message, level: 1, component: "ReflectionCrud", line: 160 })
                }
                else {
                    handleDeleteQuestion()
                }
            })
        }
        else (handleDeleteQuestion())
    }

    const fetchUpdateOrder = (replaceIndex) => {
        if (reflection[index].id && reflection[replaceIndex].id) {
            var data = {
                firstId: reflection[index].id,
                secondId: reflection[replaceIndex].id
            }
            assessmentsApi.assessmentsSortExchangePost({ exchangeAssessmentSortUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsUpdatePost " + error.message, level: 1, component: "ReflectionCrud", line: 136 })
                }
                else {
                    handleChangeOrder(index, replaceIndex)
                }
            })
        }

    }

    useEffect(() => {
        if (questionItem && questionItem.type && questionItem.text && questionItem.id) {
            fetchUpdate(questionItem)
        }
        else if (questionItem && questionItem.type && questionItem.text) {
            fetchCreate(questionItem)
        }
        else if (questionItem && !questionItem.text) {
            handleUpdateQuestion(questionItem)
        }
    }, [questionItem])


    return (
        <div className={classes.AddReflection}>
            <ReflectionToolBar
                question={reflection[index]}
                currentIndex={index}
                deleteReflectionCallback={fetchDelete}
                copyReflection={fetchCreate}
                exchangeOrder={fetchUpdateOrder}
                listLength={reflection.length}
                portalId={portalId} />
            <QuestionType setQuestion={setQuestion} question={reflection[index]} />
            <QuestionText setQuestion={setQuestion} question={reflection[index]} index={index} />
        </div>
    )
}

export default ReflectionCrud
